module.exports = __webpack_public_path__ + "img/topics1.19f3be06.jpg";